export default __webpack_public_path__ + "static/media/footer_logo.ab8ffcac.png";